<template>
  <div
    class="container-payments"
    v-if="payment_data.payments.length > 0 && project"
  >
    <h2 class="text-center text-bold mt-4">
      Contrato Nº
      {{ new Intl.NumberFormat("es-CL").format(payment_data.contract_number) }}
    </h2>
    <br />
    <b-overlay :show="loading" rounded="lg" spinner-variant="gold">
      <b-row style="width: 100%" class="content-card">
        <b-col class="px-0">
          <b-table-simple condensed borderless hover>
            <tbody>
              <b-tr
                class="d-none d-lg-table-row text-white text-center"
                style="background-color: #707070"
              >
                <b-th>Descripción</b-th>
                <b-th>Monto Pactado</b-th>
                <b-th>Fecha Pactada</b-th>
                <b-th>Estado</b-th>
                <b-th>{{ country == 0 ? "Comprobante" : "Acción" }}</b-th>
              </b-tr>
              <template v-for="(payment, key) in pageOfItems">
                <b-tr
                  :key="'pay-tr' + key"
                  class="d-none d-lg-table-row payment-table"
                >
                  <b-td>
                    {{ payment.descripcionPago }}
                    <b v-if="payment.pagoCuota">- {{ payment.cuota }}</b>
                  </b-td>
                  <b-td>
                    {{
                      parseFloat(payment.montoPago) > 0
                        ? new Intl.NumberFormat("es-CL").format(
                            payment.montoPago
                          )
                        : 0
                    }}
                    {{ country == 0 ? "" : "UF" }}
                  </b-td>
                  <b-td>
                    {{
                      (gcVersion == 1
                        ? payment.fechaVencimientoPago
                        : payment.fechaVencimientoPago.toString().slice(0, 10))
                        | moment("DD-MM-YYYY")
                    }}
                  </b-td>
                  <b-td>
                    <h5>
                      <b-badge v-if="is_payed(payment)" variant="success">{{
                        text_payed(payment)
                      }}</b-badge>
                      <b-badge
                        v-else-if="
                          parseFloat(payment.montoPago) > 0 &&
                          payment.fechaVencimientoPago < date_today &&
                          ![
                            'Crédito Hipotecario',
                            'Pie Crédito Directo',
                            'Pie Promesa',
                          ].includes(payment.descripcionPago)
                        "
                        variant="danger"
                        >Atrasado</b-badge
                      >
                      <b-badge
                        v-else-if="automated && payment.pagoCuota"
                        variant="secondary"
                        >Programado</b-badge
                      >
                      <b-badge
                        v-else-if="
                          parseFloat(payment.montoPago) > 0 &&
                          (payment.pagoCuota || customer == 'clab')
                        "
                        variant="secondary"
                        >Sin Pagar</b-badge
                      >
                      <b-badge v-else variant="sin-pagar">-</b-badge>
                    </h5>
                  </b-td>
                  <b-td>
                    <b-button
                      block
                      v-if="is_payed(payment)"
                      squared
                      variant="secondary"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      target="_blank"
                      >{{ country == 0 ? "Boleta" : "Recibo" }}</b-button
                    >
                    <template v-else>
                      <b-link
                        v-if="
                          country == 1 &&
                          parseFloat(payment.montoPago) > 0 &&
                          project.activoPagosWeb &&
                          payment.descripcionPago != 'Crédito Hipotecario'
                        "
                        class="btn my-2 my-sm-0 btn-customer btn-block rounded-0"
                        :href="`${integrationUrl}otrospagos/link?rut=${rut}&customer_id=${customerId}&project_id=${apartment.project_id}&version=${gcVersion}`"
                        target="_blank"
                        >Pagar</b-link
                      >
                      <span v-else>-</span>
                    </template>
                  </b-td>
                </b-tr>
                <b-tr :key="'small-pay-tr' + key" class="d-lg-none">
                  <b-td>
                    <b>{{ payment.descripcionPago }}</b> <br />
                    {{
                      new Intl.NumberFormat("es-CL").format(payment.montoPago)
                    }}
                    {{ country == 0 ? "" : "UF" }} <br />
                    <small>
                      {{
                        (gcVersion == 1
                          ? payment.fechaVencimientoPago
                          : payment.fechaVencimientoPago
                              .toString()
                              .slice(0, 10)) | moment("DD-MM-YYYY")
                      }}</small
                    >
                    <h5>
                      <b-badge v-if="is_payed(payment)" variant="success">{{
                        text_payed(payment)
                      }}</b-badge>
                      <b-badge
                        v-else-if="
                          parseFloat(payment.montoPago) > 0 &&
                          payment.fechaVencimientoPago < date_today &&
                          ![
                            'Crédito Hipotecario',
                            'Pie Crédito Directo',
                            'Pie Promesa',
                          ].includes(payment.descripcionPago)
                        "
                        variant="danger"
                        >Atrasado</b-badge
                      >
                      <b-badge
                        v-else-if="automated && payment.pagoCuota"
                        variant="secondary"
                        >Programado</b-badge
                      >
                      <b-badge
                        v-else-if="parseFloat(payment.montoPago) > 0"
                        variant="secondary"
                        >Sin Pagar</b-badge
                      >
                      <b-badge v-else variant="secondary">-</b-badge>
                    </h5>
                  </b-td>
                  <b-td class="align-middle text-right">
                    <b-button
                      block
                      v-if="is_payed(payment)"
                      squared
                      variant="customer"
                      class="my-2 my-sm-0"
                      type="button"
                      :href="payment.urlReport"
                      target="_blank"
                      >{{ country == 0 ? "Boleta" : "Recibo" }}</b-button
                    >
                    <template v-else>
                      <b-link
                        v-if="
                          country == 1 &&
                          parseFloat(payment.montoPago) > 0 &&
                          project.activoPagosWeb &&
                          payment.descripcionPago != 'Crédito Hipotecario'
                        "
                        class="btn my-2 my-sm-0 btn-customer btn-block rounded-0"
                        :href="`${integrationUrl}otrospagos/link?rut=${rut}&customer_id=${customerId}&project_id=${apartment.project_id}&version=${gcVersion}`"
                        target="_blank"
                        >Pagar</b-link
                      >
                      <span v-else>-</span>
                    </template>
                  </b-td>
                </b-tr>
              </template>
            </tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <div class="text-right">
        <jw-pagination
          :pageSize="10"
          :items="payment_data.payments"
          @changePage="onChangePage"
          :styles="customStyles"
          :labels="customLabels"
        ></jw-pagination>
      </div>
    </b-overlay>
  </div>
</template>
<script>
export default {
  name: "paymentsOtrosPagos",
  components: {},
  props: {
    asset_id: null,
  },
  data() {
    return {
      showPayment: true,
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      transbank: {
        token: "",
        url: "",
        monto: "",
        concept: "",
        back_url: window.location.href,
        id: "",
        loading: false,
      },
      pageOfItems: [],
      Apartment: null,
      loading: true,
      payment_data: {
        contract_number: "",
        payments: [],
        loading: null,
      },
      rut: this.$auth.watch.data.rut.replace(/-/g, ""),
    };
  },
  mounted() {
    let self = this;
    this.axios.get("payments/").then((result) => {
      result.data.map(function (value) {
        self.loading = false;
        value.bienes.map(function (v) {
          if (self.asset_id == v.id) {
            self.payment_data.contract_number = value.id;
            self.Apartment = v;
            self.payment_data.payments = value.pagos;
            self.payment_data.loading = false;
            self.$store.commit("setContractId", value.id);
          }
        });
      });
    });
  },
  methods: {
    text_payed(payment) {
      if (payment.reciboPago.length > 0) {
        return ["CANCELADO", "DEPOSITADO"].includes(
          payment.reciboPago[0].estadoPago
        )
          ? "Pagado"
          : payment.reciboPago[0].estadoPago;
      }
    },
    webpay_payment() {
      this.transbank.loading = true;
      this.axios
        .post("payments/webpay", { transbank: this.transbank })
        .then((result) => {
          this.transbank.token = result.data.token;
          this.transbank.url = result.data.url;
          this.transbank.loading = false;
          if (this.transbank.token)
            document.getElementById("webpay-token").value = result.data.token;
          document.getElementById("webpay-form").action = result.data.url;
          document.getElementById("webpay-form").submit();
        })
        .catch(() => {
          this.transbank.loading = false;
        });
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    showModal(payment) {
      this.$refs["my-modal"].show();
      this.transbank.id = payment.codigo;
      this.transbank.monto = parseInt(payment.montoPago * payment.valorUF);
    },
    is_payed(payment) {
      if (payment.reciboPago === undefined) {
        return false;
      } else {
        return payment.reciboPago.length > 0 ? true : false;
      }
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : null;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    project() {
      return this.$store.getters.getProjectByMoby(this.apartment.project_id);
    },
    apartment() {
      return this.$store.getters.getApartmentById(parseInt(this.asset_id));
    },
    date_today() {
      return this.$moment(new Date()).format("YYYY-MM-DD");
    },
    automated() {
      return this.$store.getters.getAutomatedPayments;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
    integrationUrl() {
      return this.$store.getters.getIntegrationUrl;
    },
  },
};
</script>
<style></style>
